function populateSiblingProducts() {
  const form = document.querySelector('.product-purchase-form')
  if (!form) {
    return
  }

  const productId = form.dataset.productId
  if (!productId?.length) {
    return
  }

  let currentProductHandle = null
  let styleCode = null
  try {
    const product = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML)
    currentProductHandle = product?.handle
    styleCode = product?.tags?.find(tag => tag?.startsWith('style:'))?.split(':')?.[1]
    console.log("styleCode", styleCode);
    if (!styleCode?.length) {
      return
    }
  } catch (e) {
    return
  }

  const query = `
    {
      products(first: 250, query:"tag:'style:${styleCode}'") {
        edges {
          node {
            handle
            featuredImage {
              url(transform: { maxWidth: 300 })
            }
            tags
          }
        }
      }
    }
  `

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '9c445d937bc8968e99e6c343c7de362b',
    },
    body: JSON.stringify({ query }),
  }

  fetch('https://portier-australia-pty-ltd.myshopify.com/api/2023-07/graphql', options)
    .then((response) => response.json())
    .then((data) => {
      const products = data?.data?.products?.edges?.map(edge => ({
        handle: edge?.node?.handle,
        image: edge?.node?.featuredImage?.url,
        color: edge?.node?.tags?.find(tag => tag?.startsWith('colour:'))?.split(':')?.[1],
      }))?.sort((a, b) => {
        if (a?.handle === currentProductHandle && b?.handle !== currentProductHandle) return -1
        if (b?.handle === currentProductHandle && a?.handle !== currentProductHandle) return 1
        return 0
      })

      console.log('products', products);

      if (!products?.length) {
        return
      }

      const siblingPickerDiv = document.querySelector('.sibling-picker')
      if (!siblingPickerDiv) {
        return
      }

      const colorDiv = document.createElement('div')
      colorDiv.className = 'sibling-color-wrapper'
      colorDiv.innerHTML = `<span class="sibling-color-title">Colour</span>: ${products?.[0]?.color}`

      const gridDiv = document.createElement('div')
      gridDiv.className = 'sibling-grid'

      products?.forEach(p => {
        const siblingDiv = document.createElement('a')
        siblingDiv.className = 'sibling'
        siblingDiv.href = `/products/${p?.handle}`

        const imageDiv = document.createElement('img')
        imageDiv.src = p?.image
        siblingDiv.appendChild(imageDiv)

        gridDiv.appendChild(siblingDiv)
      })

      siblingPickerDiv.appendChild(colorDiv)
      siblingPickerDiv.appendChild(gridDiv)
    })
    .catch((error) => {});
}

(function ($) {
  populateSiblingProducts()
})(theme.jQuery);

/**
 * Bottom-fixed add-to-cart bar for the product page.
 * The bar is a remote control for the main product form: its selects drive
 * the main option selectors and its button mirrors whichever call to action
 * the form is currently showing, so theme.OptionManager and the apps stay the
 * single source of truth. The select mirror runs on variantChanged (the
 * buy-with upsell forms inside the same container bubble that event too, hence
 * the evt.target check); the button mirror runs off a MutationObserver on the
 * purchase form, which also covers the ajax lockout states and apps hiding,
 * replacing or injecting the button.
 */
if (!customElements.get('sticky-add-to-cart')) {
  // The only buttons the bar will mirror. A submit CTA (theme Add to Cart /
  // Pre-order / Sold out, Globo's coming-soon button) is driven by submitting
  // the main form; a delegate CTA opens an app modal and is driven by clicking
  // the real button. Anything else in the purchase form, DROP A HINT included,
  // is deliberately not a candidate.
  const SUBMIT_CTA = 'button[type="submit"]'
  const DELEGATE_CTA = '.gBackInStockBtn, .bis-trigger'
  const ANY_CTA = SUBMIT_CTA + ', ' + DELEGATE_CTA

  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('.shopify-section') || document
      this.productForm = scope.querySelector('.product-form[data-product-id="' + this.dataset.productId + '"]')
      this.purchaseForm = this.productForm?.querySelector('form.product-purchase-form[data-product-id="' + this.dataset.productId + '"]')
      this.submitButton = this.querySelector('.sticky-atc__submit')
      this.submitText = this.querySelector('.sticky-atc__submit-text')
      this.footer = document.getElementById('pagefooter')

      // Deliberately not gated on a CTA existing yet: Globo hides the theme's
      // button and injects its own over several ticks, so a product can have
      // no visible CTA at connect and a Notify Me a second later. The
      // MutationObserver below brings the bar to life when that happens.
      // The `hidden` fallback form (rendered when the template has no
      // buy_buttons block) is the one case that never gains a CTA, so it still
      // bails rather than leaving a no-op scroll listener behind.
      if (!this.productForm || !this.purchaseForm || this.purchaseForm.classList.contains('hidden')) {
        return
      }

      this.onScroll = () => this.evaluate()
      window.addEventListener('scroll', this.onScroll, { passive: true })

      this.onResize = () => {
        if (this.classList.contains('sticky-atc--visible')) {
          this.setOffsetVar()
        }
        this.evaluate()
      }
      theme.jQuery(window).on('debouncedresize.stickyAtc', this.onResize)

      if (!this.listenersBound) {
        this.querySelectorAll('.sticky-atc__option').forEach((select) => {
          select.addEventListener('change', () => this.applyOption(select))
        })
        // Let the browser submit only when the CTA really is a submit button.
        // With no visible CTA at all the bar must stay inert: syncButton left
        // `type` on its last value, so without this a click could still post
        // the form for a product that is showing nothing to buy.
        this.submitButton.addEventListener('click', (evt) => {
          const main = this.mainButton()
          if (main && !main.matches(DELEGATE_CTA)) {
            return
          }
          evt.preventDefault()
          main?.click()
        })
        this.listenersBound = true
      }

      this.onVariantChanged = (evt, variant) => {
        if (evt.target !== this.productForm) {
          return
        }
        this.syncFromMain(variant)
        this.evaluate()
      }
      theme.jQuery(this.productForm).on('variantChanged.stickyAtc', this.onVariantChanged)

      this.formObserver = new MutationObserver(() => {
        this.syncButton()
        this.evaluate()
      })
      // The CTA's position, not just the form's contents, decides visibility,
      // and it keeps moving after connect as images above it load. Without
      // this the bar stays hidden on load on a PDP whose CTA starts below the
      // fold, because nothing re-evaluates until the first scroll or resize.
      // Watching body height catches every such reflow; the bar itself is
      // fixed and only ever drives transforms, so this cannot feed back.
      this.layoutObserver = new ResizeObserver(() => this.evaluate())
      this.layoutObserver.observe(document.body)

      this.formObserver.observe(this.purchaseForm, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'disabled']
      })

      this.syncFromMain(false)
      this.evaluate()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll)
      theme.jQuery(window).off('debouncedresize.stickyAtc', this.onResize)
      this.formObserver?.disconnect()
      this.layoutObserver?.disconnect()
      if (this.productForm) {
        theme.jQuery(this.productForm).off('variantChanged.stickyAtc', this.onVariantChanged)
      }
      document.body.classList.remove('sticky-atc-visible')
    }

    // The CTA the shopper can actually see. Visibility matters, not document
    // order: on a Globo back-in-stock variant the theme's own submit button is
    // still in the form but hidden (gPreorderHidden), and the live button is
    // the app's NOTIFY ME further down.
    mainButton() {
      if (!this.purchaseForm) {
        return null
      }
      const candidates = this.purchaseForm.querySelectorAll(ANY_CTA)
      for (let i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null) {
          return candidates[i]
        }
      }
      return null
    }

    setOffsetVar() {
      document.documentElement.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px')
    }

    evaluate() {
      const main = this.mainButton()
      let ctaOutOfView = false
      if (main) {
        // Fully out of sight in either direction, at every breakpoint. The
        // sticky header occludes the top of the viewport, so the CTA counts as
        // gone once it is behind it, not once it passes y=0.
        const rect = main.getBoundingClientRect()
        ctaOutOfView = rect.bottom <= theme.stickyHeaderHeight() || rect.top >= window.innerHeight
      }
      const footerEndReached = this.footer ? this.footer.getBoundingClientRect().bottom <= window.innerHeight + 2 : false
      const visible = ctaOutOfView && !footerEndReached
      if (visible && !this.classList.contains('sticky-atc--visible')) {
        this.setOffsetVar()
      }
      this.classList.toggle('sticky-atc--visible', visible)
      document.body.classList.toggle('sticky-atc-visible', visible)
    }

    applyOption(select) {
      const selector = this.productForm.querySelector('.option-selector[data-option-index="' + select.dataset.optionIndex + '"]')
      if (!selector || !select.value.length) {
        return
      }
      if (selector.dataset.selectorType === 'dropdown') {
        selector.querySelector('.cc-select')?.dispatchEvent(new CustomEvent('selectOption', { detail: { value: select.value } }))
      } else {
        const input = selector.querySelector('input.js-option[value="' + CSS.escape(select.value) + '"]')
        if (input && !input.checked) {
          input.checked = true
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    }

    syncFromMain(variant) {
      if (variant) {
        this.querySelectorAll('.sticky-atc__option').forEach((select) => {
          const value = variant.options[Number(select.dataset.optionIndex)]
          if (Array.prototype.some.call(select.options, (option) => option.value === value)) {
            select.value = value
          }
        })
      }
      this.syncButton()
    }

    syncButton() {
      const main = this.mainButton()
      if (!main) {
        return
      }
      // Classify by the selector that matched, never by main.type: a <button>
      // with no type attribute (the theme's own Notify Me trigger) reports
      // "submit", which would make the bar add to cart instead of opening the
      // modal. A form-associated type="button" is inert, so the form attribute
      // can stay put either way, and theme.js's error-popup anchor filters on
      // button[type="submit"] and skips the bar exactly when it should.
      this.submitButton.type = main.matches(DELEGATE_CTA) ? 'button' : 'submit'
      this.submitText.innerHTML = main.innerHTML
      this.submitButton.classList.toggle('button--sold-out', main.classList.contains('button--sold-out'))
      this.submitButton.disabled = main.disabled
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart)
}
